import { render, staticRenderFns } from "./ListagemUsuarios.vue?vue&type=template&id=562c3853"
import script from "./ListagemUsuarios.vue?vue&type=script&lang=js"
export * from "./ListagemUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports